import { useConfig } from '@/composables';
import { FirebaseApp, initializeApp } from 'firebase/app';
import { singleton } from 'tsyringe';
const config = useConfig();

@singleton()
export class FirebaseAppInstance {
  app: FirebaseApp | undefined;

  constructor() {
    if (config.value.firebaseConfig) {
      this.app = initializeApp(config.value.firebaseConfig);
    }
  }
}
